import {
  Box,
  Card,
  Grid,
  InputAdornment,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import styles from "../devoteeService.module.scss";
import commonStyles from "../../../App.module.scss";
import { useEffect, useState } from "react";
import { ValidationError, number, object, string } from "yup";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import Dialog, { type DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import constants from "../../../config/constants.json"
import { isBoolean, isNil } from "lodash";
import {
  CustomSelect,
  CustomMenuItem,
  CustomCloseIcon,
  CommonOutlinedButton,
  CommonButton,
  CustomInputLabel,
  CustomTextFeild,
  CustomLeftIcon,
  CustomBadge,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomDeleteCircleIcon,
  CustomRequiredInputLabel,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserDetails,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import {
  cartItemListProps,
  donationPurposeProps,
} from "../../../infrastructure/GlobalContextProvider";
import toast, { Toaster } from "react-hot-toast";
import ToastSuccess from "../../common/toast/toastSuccess";
import IconButton from "@mui/material/IconButton";
import cartIcon from "../../../assets/svg/Cart.svg";
import CloseIcon from "@mui/icons-material/Close";
import ToastError from "../../common/toast/toastError";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomAddCircleIcon } from "../../common/StyledComponents/StyledFields";
import dayjs from "dayjs";
import LOCALE from '../../../config/en-us.json'
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { CartComponent } from "../../common/cartItemsComponent/cartComponent";

interface formDataTypes {
  id?: number | null | undefined;
  username: string;
  purposeOfDonation: string;
  noOfItem: string;
  ammountinDollars: number;
  description: string;
}

interface ErrorDataTypes {
  username: string;
  purposeOfDonation: string;
  noOfItem: string;
  ammountinDollars: string;
  description: string;
}
interface DonationServiceProps {
  showHeaders?: boolean;
  username: string;
  onBackClick?: () => void;
}

const ServiceDonation = (props: DonationServiceProps) => {
  const [showExtraFields, setShowExtraFields] = useState<boolean>(false);
  const [formData, setFormData] = useState<formDataTypes>({
    username: props.username || "",
    purposeOfDonation: "",
    noOfItem: "",
    ammountinDollars: 0,
    description: "",
  });
  const [errorMessage, setErrorMessage] = useState<ErrorDataTypes>({
    username: "",
    purposeOfDonation: "",
    noOfItem: "",
    ammountinDollars: "",
    description: "",
  });
  const [selectedId, setSelectedId] = useState<number | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [donationPurposeItems, setDonationPurposeItems] = useState([]);
  const [isAnadanna, setIsAnadanna] = useState<boolean>(false);
  const [isVastra, setIsVastra] = useState<boolean>(false);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [showList, setShowList] = useState<boolean>(false);
  const [annadanaCount, setAnnadanaCount] = useState<number>(1);
  const [vastraCount, setVastraCount] = useState<number>(1);
  const [serivesText, setServiceText] = useState<string[]>(
    Array.from({ length: annadanaCount }, () => "")
  );
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(
    Array.from({ length: annadanaCount }, () => false)
  );
  const [serviceDates, setServiceDates] = useState<string[]>(
    Array.from({ length: annadanaCount }, () => "")
  );
  const [serivesVastraText, setServicevastraText] = useState<string[]>(
    Array.from({ length: vastraCount }, () => "")
  );

  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = object().shape({
    username: string().required("Name is required"),
    purposeOfDonation: string().required(
      "Please select the purpose of donation"
    ),
    // noOfItem: string().required("No. of item is required"),
    ammountinDollars: number()
      .required("Amount in Dollars is required")
      .min(1, "Minimum donation amount is 1")
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      }),
    description: string().required("Description is required"),
  });

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      // includeToken: true,
    })
      .then((res) => {
        console.log(res.data, "donationlistttttttttttt");
        setDonationPurposeItems(res.data);
      })
      .catch((err) => {
        console.log(err, "donationerrorrrrr");
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);

  const getHeaders = (): boolean => {
    if (
      !isNil(props.showHeaders) &&
      isBoolean(props.showHeaders) &&
      props.showHeaders === false
    ) {
      return false;
    } else {
      return true;
    }
  };


  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: props.username
      }
    })
      .then((res) => {
        setShowList(false);
        setcartItemsList(res.data.bookedItemInCart);
        setTotalDonationAmount(res.data.totalAmount);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const addTocartApi = () => {
    const reqbody = {
      onBehalfOfUsername: formData.username?.toUpperCase(),
      amount: formData.ammountinDollars,
      donationsPurposeId: formData.purposeOfDonation,
      description: formData.description,
      serviceDate: serviceDates,
      displayMessages: serivesText,
      vastraCodes: serivesVastraText,
      annadana: isAnadanna,
      vastra: isVastra,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.addDonationToCart,
      includeToken: true,
      body: JSON.stringify(reqbody),
    })
      .then((res) => {
        console.log(res.data);
        setLoading(false);
        setFormData({
          username: props.username || "",
          purposeOfDonation: "",
          noOfItem: "",
          ammountinDollars: 0,
          description: "",
        });
        setServiceDates([]);
        setServiceText([""]);
        
        // toast.custom(<ToastSuccess message={LOCALE.DONATION_ITEM_ADDED_TO_CART} />);
        toast.custom(<SuccessPopup headerMessage="Items Added" showMessage={LOCALE.DONATION_ITEM_ADDED_TO_CART} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
        getCartItems();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const handleAdd = async (): Promise<void> => {
    const errors: ErrorDataTypes = {
      username: "",
      purposeOfDonation: "",
      noOfItem: "",
      ammountinDollars: "",
      description: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      addTocartApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorDataTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "purposeOfDonation") {
      const selectedDonation: any = donationPurposeItems.find(
        (donation: donationPurposeProps) => donation.accountNumber === value
      );
      setFormData({
        ...formData,
        [field]: value,
      });
      if (!isNil(selectedDonation)) {
        const donationName = selectedDonation?.accountDescription;
        if (donationName === "ANNADAANA") {
          setIsAnadanna(true);
          setIsVastra(false);
        } else if (donationName === "VASTRA") {
          setIsVastra(true);
          setIsAnadanna(false);
        } else {
          setServiceText([]);
          setServiceDates([]);
          setIsAnadanna(false);
          setIsVastra(false);
        }
      }
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const handleDatePickerChange = (index: number, date: any) => {
    const formattedDate = dayjs(date, "MM-DD-YYYY");
    const newServiceDates = [...serviceDates];
    newServiceDates[index] = formattedDate.isValid()
      ? formattedDate.format("MM-DD-YYYY")
      : "";

    setServiceDates(newServiceDates);
  };

  const DonationPurposeDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="purposeDonation"
          placeholder="select Type donation"
          value={formData.purposeOfDonation}
          onChange={(e) => {
            handleFieldChange("purposeOfDonation", e.target.value);
            setErrorMessage({ ...errorMessage, purposeOfDonation: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.purposeOfDonation
              ? styles.errorTextField
              : styles.textField
          }
        >
          {donationPurposeItems.map(
            (item: donationPurposeProps, index: number) => (
              <CustomMenuItem key={index} value={item.accountNumber}>
                {item.accountDescription}
              </CustomMenuItem>
            )
          )}
        </CustomSelect>
        {errorMessage.purposeOfDonation ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.purposeOfDonation}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const navigateBack = () => {
    getCartItems()
  };

  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const tableDataComponent = () => {
    return (
      <div>
        <div className={styles.backArrow}>
          <div onClick={navigateBack} style={{ marginRight: "10px" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        {cartItemsList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                {/* <th className={styles.tableHorizontal}>Pooja Title</th> */}
                <th className={styles.tableHorizontal}>Deities</th>
                <th className={styles.tableHorizontal}>Date of Pooja</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>Suggested Donation Amount</th>
                <th className={styles.tableHorizontal}>Tangible Amount</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {cartItemsList.map((item: cartItemListProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item?.type}</td>
                  <td className={styles.tableDiagonal}>{item.priestName}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.deities?.map((diety) => (
                      <>
                        {diety}
                        <br />
                      </>
                    ))}
                  </td>
                  <td className={styles.tableDiagonal}>{item?.dateOfPooja}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.donationPurpose}
                  </td>
                  <td className={styles.tableDiagonal}>{formatAmount(item?.amount)}</td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.tangibleAmount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
        {cartItemsList.length > 0 && (
          <div className={styles.totalAmount}>
            <p>Total {formatAmount(totalDonationAmount)}</p>
          </div>
        )}
      </div>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };

  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      apiRequest({
        method: "DELETE",
        includeToken: true,
        endpoint: `${apiPath.deleteCartItem}/${selectedId}`,
      })
        .then((res) => {
          console.log(res.data);
          getCartItems();
          // Close the dialog
          handleClose();
          // toast.custom(<ToastSuccess message={LOCALE.ITEM_DELETED} />);
          toast.custom(<SuccessPopup headerMessage="Items Deleted" showMessage={LOCALE.ITEM_DELETED} isOpen={isOpen} setIsOpen={setIsOpen} />);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Item ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const listComponentAndPayment = (): JSX.Element => {
    return (
      <>
        {getHeaders() ? (
          <Typography component="div" className={styles.typoGraphyHeading}>
            Devotee Service
          </Typography>
        ) : (
          ""
        )}
        <div style={{ width: "100%" }}>
          {tableDataComponent()}
          {cartItemsList.length > 0 && <ModeofPayment />}
          {dialogPopup()}
        </div>
      </>
    );
  };

  useEffect(() => {
    handleCloseDatePicker(serviceDates.length - 1);
  }, [serviceDates]);

  const handleDatePickerClick = (index: number) => {
    const newIsDatePickerOpen = [...isDatePickerOpen];
    newIsDatePickerOpen[index] = true;
    setIsDatePickerOpen(newIsDatePickerOpen);
  };

  const handleCloseDatePicker = (index: number) => {
    const newIsDatePickerOpen = [...isDatePickerOpen];
    newIsDatePickerOpen[index] = false;
    setIsDatePickerOpen(newIsDatePickerOpen);
  };

  const BasicDatePicker = (index: number): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px", border: "1px solid rgba(136, 46, 20, 0.4)" }}  id={`${index}`}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={() => handleDatePickerClick(index)}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen[index]}
                onClose={() => handleCloseDatePicker(index)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  serviceDates[index]
                    ? dayjs(serviceDates[index], "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(date) => handleDatePickerChange(index, date)}
                className={styles.dateFeild}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const serviceTextComponent = (index: number) => {
    return (
      <div id={`${index}`}>
        <CustomInputLabel>Message to Be Displayed on TV</CustomInputLabel>
        <CustomTextFeild
          fullWidth
          required
          className={styles.textField}
          value={serivesText[index]}
          onChange={(e) => {
            const newTextValues = [...serivesText];
            newTextValues[index] = e.target.value;
            setServiceText(newTextValues);
          }}
          placeholder="Enter Message"
        />
      </div>
    );
  };

  const buttonsComponent = (index: number) => {
    return (
      <div  id={`${index}`} style={{marginTop:"25px"}}>
        <IconButton
          sx={{ marginTop: "auto", marginBottom: "auto" }}
          onClick={() => handleAddAnnadana(index)}
        >
          <CustomAddCircleIcon />
        </IconButton>
        {annadanaCount === 1 ? (
          ""
        ) : (
          <IconButton
            sx={{ marginTop: "auto", marginBottom: "auto" }}
            disabled={annadanaCount === 1}
            onClick={() => handleDeleteAnnadana(index)}
          >
            <CustomDeleteCircleIcon />
          </IconButton>
        )}
      </div>
    );
  };

  const annadannaComponent = (index: number) => {
    return (
      <Grid container spacing={2} id={`${index}`}>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Service Date</CustomInputLabel>
          {BasicDatePicker(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {serviceTextComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {buttonsComponent(index)}
        </Grid>
      </Grid>
    );
  };

  const handleAddVastra = (index: number) => {
    setVastraCount((prevCount) => prevCount + 1);
  };

  const handleDeleteVastra = (index: number) => {
    if (vastraCount > 1) {
      setVastraCount((prevCount) => prevCount - 1);
      const newServiceDates = [...serviceDates];
      const newMessages = [...serivesText];
      newServiceDates.splice(index, 1);
      newMessages.splice(index, 1);
      setServiceDates(newServiceDates);
      setServiceText(newMessages);
    }
  };

  const serviceDatePicker = (index: number): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px", marginTop: "12px", border: "1px solid rgba(136, 46, 20, 0.4)" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={() => handleDatePickerClick(index)}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen[index]}
                onClose={() => handleCloseDatePicker(index)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  serviceDates[index]
                    ? dayjs(serviceDates[index], "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(date) => handleDatePickerChange(index, date)}
                className={styles.dateFeild}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const vastraCodeTextComponent = (index: number) => {
    return (
      <>
        <CustomInputLabel>Vastra Code</CustomInputLabel>
        <CustomTextFeild
          fullWidth
          required
          className={styles.textField}
          value={serivesVastraText[index]}
          onChange={(e) => {
            const newTextValues = [...serivesVastraText];
            newTextValues[index] = e.target.value;
            setServicevastraText(newTextValues);
          }}
          placeholder="Enter Message"
        />
      </>
    );
  };

  const buttonsVastraComponent = (index: number) => {
    return (
      <div>
        <IconButton
          sx={{ marginTop: "auto", marginBottom: "auto" }}
          onClick={() => handleAddVastra(index)}
        >
          <CustomAddCircleIcon />
        </IconButton>
        {vastraCount === 1 ? (
          ""
        ) : (
          <IconButton
            sx={{ marginTop: "auto", marginBottom: "auto" }}
            disabled={vastraCount === 1}
            onClick={() => handleDeleteVastra(index)}
          >
            <CustomDeleteCircleIcon />
          </IconButton>
        )}
      </div>
    );
  };

  const vastraComponent = (index: number) => {
    return (
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Service Date", true)}
          {serviceDatePicker(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {vastraCodeTextComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {buttonsVastraComponent(index)}
        </Grid>
      </Grid>
    );
  };

  const handleAddAnnadana = (index: number) => {
    setAnnadanaCount((prevCount) => prevCount + 1);
  };

  const handleDeleteAnnadana = (index: number) => {
    if (annadanaCount > 1) {
      setAnnadanaCount((prevCount) => prevCount - 1);
      const newServiceDates = [...serviceDates];
      const newMessages = [...serivesText];
      newServiceDates.splice(index, 1);
      newMessages.splice(index, 1);
      setServiceDates(newServiceDates);
      setServiceText(newMessages);
    }
  };

  const annadanaComponents = Array.from(
    { length: annadanaCount },
    (_, index) => (
      <div key={index} style={{ marginTop: "12px" }}>
        {annadannaComponent(index)}
      </div>
    )
  );

  const vastraComponents = Array.from({ length: vastraCount }, (_, index) => (
    <div key={index} style={{ marginTop: "12px" }}>
      {vastraComponent(index)}
    </div>
  ));


  const renderMainComponent = () => {
    return (
      <form className={styles.DonationContainer} onSubmit={handleAdd} >
        <div className={styles.formContainer}>
          {getHeaders() ? (
            <Box
              className={styles.headerAndCartContainer}
              sx={{ alignItems: "center" }}
            >
              <Typography
                className={styles.typoGraphyHeading}
                sx={{
                  fontSize: "20px !important",
                  fontWeight: "bold !important",
                }}
              >
                Donation
              </Typography>
              <div className={styles.cartContainer}>
                {!isNil(props.onBackClick) && (
                  <CommonOutlinedButton
                    onClick={props.onBackClick}
                    sx={{ marginTop: "10px", marginRight: "10px" }}
                  >
                    Back to Search devotee
                  </CommonOutlinedButton>
                )}
                <div className={styles.text}>Devotee Cart</div>
                <IconButton aria-label="cart" onClick={handleCart}>
                  <CustomBadge
                    badgeContent={cartItemsList.length}
                    color="secondary"
                  >
                    <img src={cartIcon} alt="cart Icon" />
                  </CustomBadge>
                </IconButton>
              </div>
            </Box>
          ) : (
            ""
          )}
          {!getHeaders() ? (
            <div className={styles.cartContainer}>
              <div className={styles.text}>Devotee Cart</div>
              <IconButton aria-label="cart" onClick={handleCart}>
                <CustomBadge
                  badgeContent={cartItemsList.length}
                  color="secondary"
                >
                  <img src={cartIcon} alt="cart Icon" />
                </CustomBadge>
              </IconButton>
            </div>
          ) : (
            ""
          )}
          <Card className={styles.cardContainer}>
            <div style={{ padding: "24px" }}>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Name", true)}
                  <CustomTextFeild
                    id="name"
                    fullWidth
                    required
                    value={
                      getUserSelectedRole() === constants.MANAGER_ROLE ||
                      getUserSelectedRole() ===
                        constants.ADMINSTARTIVE_ASSISTANT_ROLE ||
                      getUserSelectedRole() === constants.FRONT_DESK_ROLE ||
                      getUserSelectedRole() === constants.OFFICE_STAFF_ROLE ||
                      getUserSelectedRole() === constants.FACILITIES_ROLE
                        ? getDevoteeId()?.fullName?.toUpperCase()
                        : getUserDetails()?.toUpperCase()
                    }
                    onChange={(e) => {
                      handleFieldChange("username", e.target.value);
                      setErrorMessage({ ...errorMessage, username: "" });
                    }}
                    className={
                      errorMessage.username
                        ? styles.errorTextField
                        : styles.textField
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  {errorMessage.username ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.username}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Purpose of Donation", true)}
                  {DonationPurposeDropdown()}
                </Grid>
                {/* <Grid xs={12} sm={4} item>
                  <CustomInputLabel>No. of Item</CustomInputLabel>
                  <CustomTextFeild
                    fullWidth
                    required
                    value={formData.noOfItem}
                    onChange={(e) => {
                      handleFieldChange("noOfItem", e.target.value);
                      setErrorMessage({ ...errorMessage, noOfItem: "" });
                    }}
                    className={
                      errorMessage.noOfItem
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.noOfItem ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.noOfItem}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid> */}
                <Grid />
              </Grid>
              {isAnadanna && annadanaComponents}
              {isVastra && vastraComponents}
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Suggested Donation Amount", true)}
                  <CustomTextFeild
                    id="ammountinDollars"
                    fullWidth
                    required
                    value={formData.ammountinDollars}
                    onFocus={(e) => {
                      if (e.target.value === "0") {
                        handleFieldChange("ammountinDollars", "");
                      }
                    }}
                    onChange={(e) => {
                      let inputValue = e.target.value;
                      const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                      const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers
                      if (inputValue === "0") {
                        inputValue = "";
                      }
                      handleFieldChange("ammountinDollars", truncatedValue);
                      setErrorMessage({
                        ...errorMessage,
                        ammountinDollars: "",
                      });
                    }}
                    className={
                      errorMessage.ammountinDollars
                        ? styles.errorTextField
                        : styles.textField
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ zIndex: "1", position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    placeholder="Enter Donation Amount"
                  />
                  {errorMessage.ammountinDollars ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.ammountinDollars}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={12} item className={styles.singleFeild}>
                  <Typography
                    style={{
                      color: "red",
                      background: "yellow",
                      fontFamily: "Lato",
                      fontStyle: "normal",
                      fontSize: "14px",
                      width: "fit-content",
                    }}
                  >
                    {LOCALE.DONATION_AMOUNT_SUGGESTION}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={30} sm={13} item>
                  {CustomRequiredInputLabel("Description", true)}
                  <TextareaAutosize
                    id="description"
                    style={{ height: "89px", marginTop: "0" }}
                    required
                    value={formData.description}
                    onChange={(e) => {
                      handleFieldChange("description", e.target.value);
                      setErrorMessage({ ...errorMessage, description: "" });
                    }}
                    className={
                      errorMessage.description
                        ? styles.errorTextField
                        : styles.textArea
                    }
                  ></TextareaAutosize>

                  {errorMessage.description ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.description}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </Card>
        </div>
        <CommonButton
          sx={{ marginTop: "10px", ml: "24px" }}
          onClick={handleAdd}
          disabled={loading}
          id="add"
          type="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Please wait...
              </span>
            </>
          ) : (
            "Add"
          )}
        </CommonButton>
      </form>
    );
  };

  return (
    <>
      <Toaster /> {!showList ? renderMainComponent() : <CartComponent navigateBack={navigateBack}/>}
    </>
  );
};

export default ServiceDonation;
